// extracted by mini-css-extract-plugin
module.exports = {"containerWithArrow":"MainSlat__containerWithArrow--1HSmWsJnCA","containerWithTopArrow":"MainSlat__containerWithTopArrow--3SsakF70Ic","container":"MainSlat__container--Ll1t0vTVQZ"};